module.exports = __webpack_public_path__ + "static/media/unboxing_spring_3.f8a9ca73.jpg";